import { render, staticRenderFns } from "./RejectMailForm.vue?vue&type=template&id=404bdfd2"
import script from "./RejectMailForm.vue?vue&type=script&lang=js"
export * from "./RejectMailForm.vue?vue&type=script&lang=js"
import style0 from "./RejectMailForm.vue?vue&type=style&index=0&id=404bdfd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports